module.exports = __webpack_public_path__ + "media/images/noimage-creator@2x-27ab728c969b79f8b5ef8baa48b2725c.png";